import React from 'react';
import styled from 'styled-components';
import {Btn} from '../../../ui-toolkit/elements/button/btn-type/Btn';
import {Icon} from '../../../ui-toolkit/elements/Icon/Icon';

export const CloseBtnContainer = styled(Btn)`
    color: var(--label-text-color);
    &:hover {
        color: var(--danger);
    }
    ${Icon.Wrapper} svg {
        width: 20px;
        height: 20px;
    }
`;

export const ModalCloseBtn = ({onClick}) => (
    <CloseBtnContainer link onClick={onClick} type="button">
        <Icon type="lg" name="Close" />
    </CloseBtnContainer>
);
